module.exports = __webpack_public_path__ + "static/Burst2Mob-33e9d9bcecb851e7d9e3502ec0445ea1.jpg";